export default __webpack_public_path__ + "static/media/quizzIMG.eb08edfc.png";